export const useBlob = () => {
  const url = (imageUrl:string) => {
    return 'https://usimsaassets.blob.core.windows.net/usimsa-web'.concat(imageUrl)
  }

  return {
    url
  }
}
